require('hammerjs');
